module.exports = __webpack_public_path__ + "img/r-147.83fe6fb9.jpg";